// src/components/common/OfflineBanner.js (NEW FILE)

import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

const OfflineBanner = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!isOffline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-yellow-500 text-white text-center p-2 z-50 flex items-center justify-center shadow-lg">
      <WifiOff size={18} className="mr-2" />
      <span className="font-semibold">You are currently offline. Actions are being saved and will sync when you reconnect.</span>
    </div>
  );
};

export default OfflineBanner;